import React from 'react'
import QuestionFormPage from './QuestionFormPage'

const EditQuestion = () => {
  return (
    <div><QuestionFormPage isAdd={"Edit"}/></div>
  )
}

export default EditQuestion